import React from "react";
import {observer} from "mobx-react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import DropDown from "../../../../common/components/shared/dropDown/dropDown";
import {storesContext} from "../../../../common/stores/stores";
import Loader from "../../../../common/components/shared/loader/loader";
import Button from "../../../../common/components/shared/button/button";
import i18n from "../../../../i18n/i18n";
import ParkingRatesSection from "../parkingRatesSection/parkingRatesSection";
import {IPriceStore} from "../../../stores/priceStore";
import "./priceFormSection.scss";
import Date from "../../../../timetables/components/actionForm/dateAndTime/date";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {PriceListService} from "../../../services/priceListService";
import {Api} from "../../../../helpers/api";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import RelationTypeDropdownItems from "../../../../helpers/relationTypeDropdownItems";

interface PriceFormSectionState {
    getPriceResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isLoading: boolean;
}

interface PriceFormSectionProps extends RouteComponentProps {
    isUpdate: boolean;
    priceId?: string;
    priceIndex: number;
    isVisibleRemoveButton: boolean;
    onRemovePrice: () => void;
}

class PriceFormSection extends React.Component <PriceFormSectionProps, PriceFormSectionState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            getPriceResponse: undefined,
            isLoading: false
        };
    }

    async componentDidMount() {
        this.setState({isLoading: true});

        if (this.props.isUpdate && this.props.priceId) {
            await this.getPrice();
        }
        this.setState({isLoading: false});
    }

    render(): JSX.Element {
        const priceStore = this.context.priceStore as IPriceStore;

        if (this.state.isLoading) {
            return <Loader />;
        } else {
            return (
                <div className="price-form-section">
                    {this.props.isVisibleRemoveButton && (
                        <Button
                            text={i18n.t("remove")}
                            type="primary"
                            variant="text"
                            className="remove-price-btn"
                            testId={`remove-price-${this.props.priceIndex}`}
                            onClick={() => this.props.onRemovePrice()}
                        />
                    )}
                    <div className="section">
                        <DropDown
                            label={i18n.t("priceList.headers.priceListType")}
                            items={RelationTypeDropdownItems.getRelationTypesWithDefault()}
                            validatedValue={priceStore.priceList[this.props.priceIndex].priceListType}
                            testId={`price-list-type-${this.props.priceIndex}`}
                        />
                        <Date
                            dateLabel={i18n.t("priceList.headers.validFrom")}
                            dateValue={priceStore.priceList[this.props.priceIndex].startDate}
                            testId={`valid-from-${this.props.priceIndex}`}
                        />
                    </div>
                    <ParkingRatesSection
                        store={priceStore}
                        priceIndex={this.props.priceIndex}
                    />
                    {!Api.isSuccess(this.state.getPriceResponse) && (
                        <HttpError
                            response={this.state.getPriceResponse}
                            cause={i18n.t("priceList.errors.getPriceErrorSuffix")}
                        />
                    )}
                </div>
            );
        }
    }

    private async getPrice() {
        const priceStore = this.context.priceStore as IPriceStore;

        const response = await PriceListService.getPrice(this.props.priceId!);

        this.setState({getPriceResponse: response});
        priceStore.priceList[0].setPrice(response?.data || undefined);
    }
}

export default withRouter(observer(PriceFormSection));